import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useBetting } from '../../../../../../../context/BettingContext';
import { sendNotfication } from '../../../../../../../Helper';

// Keyframes for odds change animations
const noOddsChange = keyframes`
  0% { 
    background: linear-gradient(90deg, #ffe6e6, #ffcccc);
    box-shadow: 0 0 0 0 rgba(255, 182, 193, 0.7);
    border: 1px solid rgba(233, 30, 99, 0.4);
    transform: scale(1);
  }
  25% { 
    background: linear-gradient(90deg, #ffd4da, #ffb6c1);
    box-shadow: 0 0 8px 2px rgba(255, 182, 193, 0.6);
    border: 1px solid rgba(233, 30, 99, 0.8);
    transform: scale(1.02);
  }
  50% { 
    background: linear-gradient(90deg, #FFB6C1, #FF9BB3);
    box-shadow: 0 0 15px 4px rgba(255, 182, 193, 0.8);
    border: 1px solid rgba(233, 30, 99, 1);
    transform: scale(1.03);
  }
  75% { 
    background: linear-gradient(90deg, #ffd4da, #ffb6c1);
    box-shadow: 0 0 8px 2px rgba(255, 182, 193, 0.6);
    border: 1px solid rgba(233, 30, 99, 0.8);
    transform: scale(1.02);
  }
  100% { 
    background: linear-gradient(90deg, #ffe6e6, #ffcccc);
    box-shadow: 0 0 0 0 rgba(255, 182, 193, 0);
    border: 1px solid rgba(233, 30, 99, 0.4);
    transform: scale(1);
  }
`;

const yesOddsChange = keyframes`
  0% { 
    background: linear-gradient(90deg, #e0f7fa, #b2ebf2);
    box-shadow: 0 0 0 0 rgba(114, 187, 239, 0.7);
    border: 1px solid rgba(33, 150, 243, 0.4);
    transform: scale(1);
  }
  25% { 
    background: linear-gradient(90deg, #b2ebf2, #81d4fa);
    box-shadow: 0 0 8px 2px rgba(114, 187, 239, 0.6);
    border: 1px solid rgba(33, 150, 243, 0.8);
    transform: scale(1.02);
  }
  50% { 
    background: linear-gradient(90deg, #72BBEF, #5A9FD4);
    box-shadow: 0 0 15px 4px rgba(114, 187, 239, 0.8);
    border: 1px solid rgba(33, 150, 243, 1);
    transform: scale(1.03);
  }
  75% { 
    background: linear-gradient(90deg, #b2ebf2, #81d4fa);
    box-shadow: 0 0 8px 2px rgba(114, 187, 239, 0.6);
    border: 1px solid rgba(33, 150, 243, 0.8);
    transform: scale(1.02);
  }
  100% { 
    background: linear-gradient(90deg, #e0f7fa, #b2ebf2);
    box-shadow: 0 0 0 0 rgba(114, 187, 239, 0);
    border: 1px solid rgba(33, 150, 243, 0.4);
    transform: scale(1);
  }
`;

const Container = styled.div`
  width: 100%;
  background-color: #000000;
   font-family: 'Montserrat Alternates', sans-serif;
`;
const StatusBar = styled.div`
  background: rgb(50, 55, 56);
  color: white;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: #FF5C5C;
  }
`;
const StatusTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: bold;
   font-family: 'Montserrat Alternates', sans-serif;
  
  svg {
    width: 18px;
    height: 18px;
    fill: #FF5C5C;
  }
`;
const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 10px;
  color: #cccccc;
   font-family: 'Montserrat Alternates', sans-serif;
`;
const TabContainer = styled.div`
  display: flex;
  background: rgb(50, 55, 56);
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const Tab = styled.div`
  padding: 10px 15px;
  color: white;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
  background: ${props => props.active ? '#FF5C5C' : 'transparent'};
  border-bottom: 2px solid ${props => props.active ? '#FF5C5C' : 'transparent'};
   font-family: 'Montserrat Alternates', sans-serif;
`;

const MarketContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
//   padding: 8px;
  background: #000000;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const MarketRow = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.selected === 'no' ? '#1a1a1a' : props.selected === 'yes' ? '#1a1a1a' : '#000000'};
  border-radius: 4px;
  overflow: hidden;
  transition: background-color 0.3s ease;
  position: relative;
   font-family: 'Montserrat Alternates', sans-serif;
  margin-bottom: 8px;
  border: 1px solid rgb(50, 55, 56);
`;

const MarketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgb(50, 55, 56);
  border-bottom: 1px solid rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
`;

const MarketTitle = styled.div`
  font-size: 11px;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const InfoIcon = styled.span`
  color: #95a5a6;
  font-size: 16px;
`;

const OddsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 90px; /* match bookmaker sizing */
  gap: 0px;
  position: relative;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const OddsContainerHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 90px 90px; /* match bookmaker sizing */
  gap: 0px;
  position: relative;
  padding: 4px 0px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const OddsBox = styled.div`
  display: flex;
  width: 90px; /* fixed width to mirror bookmaker */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: ${props => (props.type === 'no' ? '#FFB6C1' : '#72BBEF')};
  border: ${props => {
    if (props.animateNo) return '1px solid rgba(233, 30, 99, 0.4)';
    if (props.animateYes) return '1px solid rgba(33, 150, 243, 0.4)';
    return '1px solid transparent';
  }};
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Montserrat Alternates', sans-serif;
  animation: ${props => {
    if (props.animateNo) return css`${noOddsChange} 2.5s cubic-bezier(0.4, 0, 0.2, 1)`;
    if (props.animateYes) return css`${yesOddsChange} 2.5s cubic-bezier(0.4, 0, 0.2, 1)`;
    return 'none';
  }};

  .odds {
    font-weight: bold;
    font-size: 10px; /* match bookmaker */
    color: black;
    transition: all 0.3s ease;
  }

  .volume {
    font-size: 8px; /* match bookmaker */
    color: black;
    transition: all 0.3s ease;
  }

  &:hover {
    transform: scale(1.02);
  }
`;

const BetSlip = styled.div`
  background: #1a1a1a;
  padding: 12px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const BetInputContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

const OddsDisplay = styled.div`
//   background: #1a1a1a;
  padding: 8px 16px;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  font-size: 12px;
  color: white;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
   font-family: 'Montserrat Alternates', sans-serif;

  .odds {
    font-weight: bold;
    font-size: 12px;
  }

  .volume {
    font-size: 8px;
    color: #cccccc;
    margin-top: 2px;
  }
`;

const AmountContainer = styled.div`
  flex: 1;
  display: flex;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  overflow: hidden;
  background: #1a1a1a;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AdjustButton = styled.div`
  width: 40px;
  border: none;
  background: rgb(50, 55, 56);
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AmountInput = styled.div`
  flex: 1;
  padding: 8px;
  text-align: center;
  font-size: 16px;
  color: white;
  min-width: 80px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const QuickAmounts = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  margin-bottom: 12px;
`;

const QuickAmount = styled.div`
  padding: 6px;
  background: #1a1a1a;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 2px;
  font-size: 10px;
  cursor: pointer;
  text-align: center;
  color: white !important;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const Numpad = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-bottom: 12px;
  color: white !important;
  text-align: center;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const NumpadButton = styled.div`
  padding: 12px;
  background: #1a1a1a;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  color: white;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  text-align: center;

`;

const Button = styled.div`
  padding: 12px;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid ${props => props.variant === 'primary' ? '#FF5C5C' : 'rgb(50, 55, 56)'};
  background: ${props => props.variant === 'primary' ? '#FF5C5C' : '#1a1a1a'};
  color: ${props => props.variant === 'primary' ? 'black' : 'white'};
  font-weight: ${props => props.variant === 'primary' ? 'bold' : 'normal'};
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 10px;
  color: white;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const StatusOverlay = styled.div`
  position: absolute;
  top: 0;
  left: calc(100% - 180px); /* cover the two right odds boxes (2 x 90px) */
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(200, 200, 200, 0.85), rgba(180, 180, 180, 0.9));
  box-shadow: inset 0 0 20px rgba(160, 160, 160, 0.4), inset 0 0 40px rgba(140, 140, 140, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  backdrop-filter: blur(1px);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(80, 80, 80, 0.15);
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      rgba(120, 120, 120, 0.1),
      rgba(100, 100, 100, 0.2)
    );
    z-index: -2;
  }
`;

const StatusText = styled.span`
  color: white !important;
  font-weight: bold;
  font-size: 12px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
   font-family: 'Montserrat Alternates', sans-serif;
`;

const handleAmountChange = (currentAmount, change) => {
  const newAmount = Number(currentAmount) + change;
  return newAmount < 0 ? '0' : String(newAmount);
};

// Move markets array outside component to prevent infinite re-renders
const markets = [
  { title: '20 Over SA', no: { odds: 59, volume: 140 }, yes: { odds: 59, volume: 50 }, status: 'active' },
  { title: '4th Wkt SA', no: { odds: 85, volume: 110 }, yes: { odds: 85, volume: 90 }, status: 'suspended' },
  { title: '4th Wkt Pship Boundaries SA', no: { odds: 5, volume: 100 }, yes: { odds: 6, volume: 100 }, status: 'ball_running' },
  { title: 'R Ricketon Runs', no: { odds: 45, volume: 110 }, yes: { odds: 45, volume: 90 }, status: 'active' },
  { title: 'Total Match Boundaries', no: { odds: 32, volume: 200 }, yes: { odds: 33, volume: 180 }, status: 'ball_running' },
  { title: '1st 6 Overs Runs SA', no: { odds: 92, volume: 150 }, yes: { odds: 93, volume: 130 }, status: 'active' },
  { title: 'D Miller Runs', no: { odds: 28, volume: 120 }, yes: { odds: 29, volume: 100 }, status: 'suspended' },
  { title: 'H Klaasen Runs', no: { odds: 41, volume: 160 }, yes: { odds: 42, volume: 140 }, status: 'active' },
  { title: 'Total Match Sixes', no: { odds: 15, volume: 180 }, yes: { odds: 16, volume: 160 }, status: 'ball_running' },
  { title: 'Total Match Wickets', no: { odds: 12, volume: 130 }, yes: { odds: 13, volume: 120 }, status: 'suspended' },
  { title: '1st Innings Score', no: { odds: 165, volume: 250 }, yes: { odds: 166, volume: 230 }, status: 'active' },
  { title: 'Highest Over Runs', no: { odds: 19, volume: 140 }, yes: { odds: 20, volume: 120 }, status: 'ball_running' }
];

const FancyBetMobile = ({ matchData, fancyData }) => {
  const [activeTab, setActiveTab] = useState('All');
  const [selectedBets, setSelectedBets] = useState({});
  const [betAmounts, setBetAmounts] = useState({});
  const [acceptAnyOdds, setAcceptAnyOdds] = useState({});
  const [previousOdds, setPreviousOdds] = useState({});
  const [animatingOdds, setAnimatingOdds] = useState({});
  const { placeBets } = useBetting();

  const tabs = ['All', 'Fancy', 'Ball by Ball', 'Khadda', 'Lottery', 'Odd/Even'];

  const quickAmounts = [100, 1000, 2000, 5000, 50000, 100000];

  // Effect to detect odds changes and trigger animations
  useEffect(() => {
    if (!fancyData || fancyData.length === 0) return;

    const currentOdds = {};
    fancyData.forEach((market, marketIndex) => {
      const noKey = `${marketIndex}-no`;
      const yesKey = `${marketIndex}-yes`;
      currentOdds[noKey] = {
        odds: market.runsNo,
        volume: market.oddsNo
      };
      currentOdds[yesKey] = {
        odds: market.runsYes,
        volume: market.oddsYes
      };
    });

    const newAnimatingOdds = {};
    fancyData.forEach((market, marketIndex) => {
      const noKey = `${marketIndex}-no`;
      const yesKey = `${marketIndex}-yes`;
      
      const prevNo = previousOdds[noKey];
      const prevYes = previousOdds[yesKey];
      
      if (prevNo && (prevNo.odds !== market.runsNo || prevNo.volume !== market.oddsNo)) {
        newAnimatingOdds[noKey] = true;
      }
      
      if (prevYes && (prevYes.odds !== market.runsYes || prevYes.volume !== market.oddsYes)) {
        newAnimatingOdds[yesKey] = true;
      }
    });

    if (Object.keys(newAnimatingOdds).length > 0) {
      setAnimatingOdds(newAnimatingOdds);
      setTimeout(() => {
        setAnimatingOdds({});
      }, 2500);
    }
    
    setPreviousOdds(currentOdds);
  }, [fancyData]);

  const handleOddsClick = (market, type) => {
    const marketKey = `${market.title}-${type}`;
    const oppositeType = type === 'no' ? 'yes' : 'no';
    const oppositeKey = `${market.title}-${oppositeType}`;

    setSelectedBets(prev => {
      const newBets = { ...prev };
      delete newBets[oppositeKey];

      if (newBets[marketKey]) {
        delete newBets[marketKey];
      } else {
        newBets[marketKey] = { market, type };
      }

      return newBets;
    });

    if (!betAmounts[marketKey]) {
      setBetAmounts(prev => ({
        ...prev,
        [marketKey]: '100'
      }));
    }
  };

  return (
    <Container>
      <StatusBar>
        <StatusTitle>
          <svg viewBox="0 0 24 24">
            <path d="M3.5,18.5L9.5,12.5L13.5,16.5L22,6.92L20.59,5.5L13.5,13.5L9.5,9.5L2,17L3.5,18.5Z" />
          </svg>
          Fancy Bet
        </StatusTitle>

      </StatusBar>


      <OddsContainerHeader>
        <div style={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '8px 0', }}></div>
        <div style={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '8px 0', }}>No</div>
        <div style={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '10px', fontWeight: 'bold', padding: '8px 0', }}>Yes</div>
      </OddsContainerHeader>

      <MarketContainer>
        {fancyData.map((market, index) => {
          const noKey = `${market.marketName}-no`;
          const yesKey = `${market.marketName}-yes`;
          const selectedType = selectedBets[noKey] ? 'no' : selectedBets[yesKey] ? 'yes' : null;

          return (
            <React.Fragment key={market.marketId}>

              <MarketRow selected={selectedType}>
                <MarketHeader>
                  <MarketTitle>
                    <span style={{ color: 'white', fontSize: '11px', }}>{market.marketName}</span>
                  </MarketTitle>
                </MarketHeader>
                <OddsContainer>
                  <div style={{ width: '100%', backgroundColor: 'transparent', padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'white', fontSize: '11px', }}>{market.marketName}</span>
                    <span style={{ color: '#cccccc', fontSize: '12px', }}>ⓘ</span>
                  </div>

                  <OddsBox
                    type="no"
                    selected={selectedBets[noKey]}
                    animateNo={animatingOdds[`${index}-no`]}
                    onClick={() => {
                      if (market.statusName !== 'ACTIVE') {
                        sendNotfication(`Market is ${market.statusName}`, 'error', 'bottom-left');
                        return;
                      }
                      handleOddsClick(market, 'no');
                    }}
                  >
                    <span className="odds">{market.runsNo}</span>
                    <span className="volume">{market.oddsNo}</span>
                  </OddsBox>

                  <OddsBox
                    type="yes"
                    selected={selectedBets[yesKey]}
                    animateYes={animatingOdds[`${index}-yes`]}
                    onClick={() => {
                      if (market.statusName !== 'ACTIVE') {
                        sendNotfication(`Market is ${market.statusName}`, 'error', 'bottom-left');
                        return;
                      }
                      handleOddsClick(market, 'yes');
                    }}
                  >
                    <span className="odds">{market.runsYes}</span>
                    <span className="volume">{market.oddsYes}</span>
                  </OddsBox>

                  {market.statusName !== 'ACTIVE' && (
                    <StatusOverlay>
                      <StatusText>
                        {market.statusName === 'SUSPEND' ? 'Suspended' : 'Ball Running'}
                      </StatusText>
                    </StatusOverlay>
                  )}

                </OddsContainer>
              </MarketRow>

              {selectedBets[noKey] && (
                <BetSlip type="no">
                  <BetInputContainer>
                    <OddsDisplay>
                      {/* <span className="odds">{market.no.odds}</span>
                                            <span className="volume">{market.no.volume}</span> */}

                      {`${market.no.odds}/${market.no.volume}`}
                    </OddsDisplay>
                    <AmountContainer>
                      <AdjustButton onClick={() => {
                        setBetAmounts(prev => ({
                          ...prev,
                          [noKey]: handleAmountChange(prev[noKey] || 0, -100)
                        }));
                      }}>-</AdjustButton>
                      <AmountInput>{betAmounts[noKey]}</AmountInput>
                      <AdjustButton onClick={() => {
                        setBetAmounts(prev => ({
                          ...prev,
                          [noKey]: handleAmountChange(prev[noKey] || 0, 100)
                        }));
                      }}>+</AdjustButton>
                    </AmountContainer>
                  </BetInputContainer>

                  <QuickAmounts>
                    {quickAmounts.map(amount => (
                      <QuickAmount
                        key={amount}
                        onClick={() => setBetAmounts(prev => ({
                          ...prev,
                          [noKey]: String(amount)
                        }))}
                      >
                        {amount}
                      </QuickAmount>
                    ))}
                  </QuickAmounts>

                  <Numpad>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '00', '×'].map((num, i) => (
                      <NumpadButton
                        key={i}
                        onClick={() => {
                          if (num === '×') {
                            setBetAmounts(prev => ({ ...prev, [noKey]: '0' }));
                          } else {
                            setBetAmounts(prev => ({
                              ...prev,
                              [noKey]: prev[noKey] === '0' ?
                                String(num) :
                                String(Number(prev[noKey] + num) || 0) // Ensures valid number or defaults to 0
                            }));
                          }
                        }}
                      >
                        {num}
                      </NumpadButton>
                    ))}
                  </Numpad>

                  <ActionButtons>
                    <Button onClick={() => {
                      setSelectedBets(prev => {
                        const newBets = { ...prev };
                        delete newBets[noKey];
                        return newBets;
                      });
                    }}>Cancel</Button>
                    <Button
                      variant="primary"
                      onClick={async () => {

                        if (market.statusName !== 'ACTIVE') {
                          sendNotfication(`Cannot place bet — Market is ${market.statusName}`, 'error', 'bottom-left');
                          return;
                        }
                        const stake = parseFloat(betAmounts[noKey] || '0');
                        const oddsNum = parseFloat(market.no.odds || '0');
                        if (!stake || stake < 4 || !oddsNum || oddsNum <= 0) {

                          sendNotfication('Enter valid stake (>=4) and odds (>0).', 'error', 'bottom-left')
                          return;
                        }
                        if (!matchData || !matchData.id || !matchData.team1 || !matchData.team2) {

                          sendNotfication('Match matchData missing', 'error', 'bottom-left')
                          return;
                        }

                        const betRow = {
                          market: 'FAN',
                          matchId: matchData.id,
                          matchTitle: `${matchData.team1} v ${matchData.team2}`,
                          selectionName: `${market.title} - No`,
                          category: 'fancy',
                          type: 'lay',
                          odds: oddsNum,
                          stake: stake,
                          liability: stake * (oddsNum / 100),
                          eventid: matchData.eventid
                        };

                        const result = await placeBets([betRow]);
                        if (result?.confirmed?.length > 0) {
                          sendNotfication('Bets placed successfully!', 'success', 'bottom-left')

                          setSelectedBets(prev => { const p = { ...prev }; delete p[noKey]; return p; });
                        } else {
                          sendNotfication(result?.errors?.[0]?.message || 'Bet placement failed', 'error', 'bottom-left');
                        }
                      }}
                    >
                      Place Bet
                    </Button>
                  </ActionButtons>

                  <AcceptOddsContainer>
                    <input
                      type="checkbox"
                      checked={acceptAnyOdds[noKey] || false}
                      onChange={() => setAcceptAnyOdds(prev => ({
                        ...prev,
                        [noKey]: !prev[noKey]
                      }))}
                    />
                    <span>Accept Any Odds</span>
                  </AcceptOddsContainer>
                </BetSlip>
              )}

              {selectedBets[yesKey] && (
                <BetSlip type="yes">
                  <BetInputContainer>
                    <OddsDisplay>

                      {`${market.yes.odds}/${market.yes.volume}`}
                    </OddsDisplay>
                    <AmountContainer>
                      <AdjustButton onClick={() => {
                        setBetAmounts(prev => ({
                          ...prev,
                          [yesKey]: handleAmountChange(prev[yesKey] || 0, -100)
                        }));
                      }}>-</AdjustButton>
                      <AmountInput>{betAmounts[yesKey]}</AmountInput>
                      <AdjustButton onClick={() => {
                        setBetAmounts(prev => ({
                          ...prev,
                          [yesKey]: handleAmountChange(prev[yesKey] || 0, 100)
                        }));
                      }}>+</AdjustButton>
                    </AmountContainer>
                  </BetInputContainer>

                  <QuickAmounts>
                    {quickAmounts.map(amount => (
                      <QuickAmount
                        key={amount}
                        onClick={() => setBetAmounts(prev => ({
                          ...prev,
                          [yesKey]: String(amount)
                        }))}
                      >
                        {amount}
                      </QuickAmount>
                    ))}
                  </QuickAmounts>

                  <Numpad>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '00', '×'].map((num, i) => (
                      <NumpadButton
                        key={i}
                        onClick={() => {
                          if (num === '×') {
                            setBetAmounts(prev => ({ ...prev, [yesKey]: '0' }));
                          } else {
                            setBetAmounts(prev => ({
                              ...prev,
                              [yesKey]: prev[yesKey] === '0' ?
                                String(num) :
                                String(Number(prev[yesKey] + num) || 0) // Ensures valid number or defaults to 0
                            }));
                          }
                        }}
                      >
                        {num}
                      </NumpadButton>
                    ))}
                  </Numpad>

                  <ActionButtons>
                    <Button onClick={() => {
                      setSelectedBets(prev => {
                        const newBets = { ...prev };
                        delete newBets[yesKey];
                        return newBets;
                      });
                    }}>Cancel</Button>
                    <Button
                      variant="primary"
                      onClick={async () => {
                        const stake = parseFloat(betAmounts[yesKey] || '0');
                        const oddsNum = parseFloat(market.yes.odds || '0');
                        if (!stake || stake < 4 || !oddsNum || oddsNum <= 0) {
                          alert('Enter valid stake (>=4) and odds (>0).');
                          return;
                        }
                        if (!matchData || !matchData.id || !matchData.team1 || !matchData.team2) {
                          alert('Match matchData missing');
                          return;
                        }

                        const betRow = {
                          market: 'FAN',
                          matchId: matchData.id,
                          matchTitle: `${matchData.team1} v ${matchData.team2}`,
                          selectionName: `${market.title} - Yes`,
                          category: 'fancy',
                          type: 'back',
                          odds: oddsNum,
                          stake: stake,
                          liability: stake * (oddsNum / 100),
                        };

                        const result = await placeBets([betRow]);
                        if (result?.confirmed?.length > 0) {
                          alert('Bet placed successfully!');
                          setSelectedBets(prev => { const p = { ...prev }; delete p[yesKey]; return p; });
                        } else {
                          alert(result?.errors?.[0]?.message || 'Bet placement failed');
                        }
                      }}
                    >
                      Place Bet
                    </Button>
                  </ActionButtons>

                  <AcceptOddsContainer>
                    <input
                      type="checkbox"
                      checked={acceptAnyOdds[yesKey] || false}
                      onChange={() => setAcceptAnyOdds(prev => ({
                        ...prev,
                        [yesKey]: !prev[yesKey]
                      }))}
                    />
                    <span>Accept Any Odds</span>
                  </AcceptOddsContainer>
                </BetSlip>
              )}
            </React.Fragment>
          );
        })}
      </MarketContainer>
    </Container>
  );
};

export default FancyBetMobile;